<template>
  <div>
  <el-dialog :title="'设置筛选条件'" :visible.sync="visible">
      <p class="block">可以只抓取包含特定词语的{{name}}</p>
      <p class="tit">抓取关键词</p>
      <div class="block">
        <input type="text" class="input width-3" v-model="inputKeywords">
        <button class="button is-success" @click="addTag('keywords')">添加</button>
      </div>
      <div class="block">
        <a v-for="(item,index) in keywords" class="tags button is-primary is-outlined" @click="deleteTag('keywords',item)">
          <span data-v-66ca9ef4="">{{item}}</span>
          <span data-v-66ca9ef4="" class="icon">
              <i data-v-66ca9ef4="" class="fa fa-times"></i>
              </span>
        </a>
      </div>
      <p class="tit">屏蔽关键词</p>
      <div class="block">
        <input type="text" class="input width-3" v-model="inputExcludeKeywords">
        <button class="button is-success" @click="addTag('excludeKeywords')">添加</button>
      </div>
      <div class="block">
        <a v-for="(item,index) in excludeKeywords" class="tags button is-primary is-outlined" @click="deleteTag('excludeKeywords',item)">
          <span data-v-66ca9ef4="">{{item}}</span>
          <span data-v-66ca9ef4="" class="icon">
              <i data-v-66ca9ef4="" class="fa fa-times"></i>
              </span>
        </a>
      </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取 消</el-button>
        <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/babel">


  export default {
    watch:{
      visible(){
        this.keywords = [],
        this.excludeKeywords = [],
        this.inputKeywords = "",
        this.inputExcludeKeywords = ""
      }
    },
    props:{
      name:String
    },
    data(){
      return {
        visible:false,
        keywords: [],
        excludeKeywords: [],
        inputKeywords: "",
        inputExcludeKeywords: "",
      }
    },
    methods: {
      //确认点击
      MODAL_OK_EVENT() {
        if(this.inputKeywords || this.inputExcludeKeywords){
          if(confirm("还有未添加的关键词,真的不要带着一起保存吗?")){
            this.$emit("subscribe-modal-ok-event",this.keywords,this.excludeKeywords);
          }
        }else{
          this.$emit("subscribe-modal-ok-event",this.keywords,this.excludeKeywords);
        }
        this.visible = false
      },
      showModal(){
        this.visible = true;
      },
      /**
       * 添加关键词
       * */
      addTag(type){
        if(type == "keywords"){
          if(!this.inputKeywords){
            this.$message("请输入关键词");
            return
          }
          if(this.keywords.indexOf(this.inputKeywords) > -1){
            this.$message("该关键词已经存在,不能重复添加");
          }else{
            this.keywords.push(this.inputKeywords)
          }
          this.inputKeywords = "";
        }else{
          if(!this.inputExcludeKeywords){
            this.$message("请输入关键词");
            return
          }
          if(this.excludeKeywords.indexOf(this.inputExcludeKeywords) > -1){
            this.$message("该关键词已经存在,不能重复添加");
          }else{
            this.excludeKeywords.push(this.inputExcludeKeywords)
          }
          this.inputExcludeKeywords = "";
        }
      },
      /**
       * 删除关键词
       * */
      deleteTag(type,value){
        if(type == "keywords"){
          this.keywords.splice(this.keywords.indexOf(value),1);
        }else{
          this.excludeKeywords.splice(this.excludeKeywords.indexOf(value),1);
        }
      }
    }
  }
</script>
<style lang="less">
  .tit{
    font-size: 16px;
    color: #000;
    font-weight: 600;
    margin-bottom: 10px;
  }
  .tags{
    margin: 0 10px 10px 0;
  }
</style>
